import { useQuery } from "@tanstack/react-query"
import { makeGetEmbeddingModels } from "../../domain/use-cases/get-embedding-models"
import { httpKnowledgeBaseRepository } from "../../data/repositories/knowledge-base-repository"

const getEmbeddingModels = makeGetEmbeddingModels(httpKnowledgeBaseRepository)

export const useEmbeddingModels = () =>
  useQuery({
    queryKey: ["embedding-models"],
    queryFn: getEmbeddingModels,
    staleTime: Infinity,
  })
